<template>
  <div>
    <div
      class="flex flex-row gap-4 sm:(gap-0 flex-col-reverse) bg-stone-50 p-2 border-stone-100 border-1 rounded-lg shadow-md overflow-scroll"
      ref="el"
    >
      <div v-for="option in options" :key="option.name" class="flex flex-col sm:flex-row gap-1 whitespace-nowrap">
        <span class="sm:text-sm text-right grow-1">{{ option.name }}</span>
        <div
          class="w-6 h-6 border-2 sm:(w-4 h-4 border-1) border-white rounded-full"
          :style="{ backgroundColor: option.color }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script setup>
// take options in the format of {name: string, color: string} and render a legend
const props = defineProps({
  options: {
    type: Array,
  },
});
// const el = ref();
// onMounted(() => {
//   // scroll to the beginning of the legend (defaults to end due to flex-direction: row-reverse)
//   el.value.scrollLeft -= el.value.scrollWidth;
// });
</script>
